import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { capitalize } from 'helpers';

import IconSelector from 'partials/IconSelector';

import Image from 'partials/Image';
import SmartLink from 'partials/SmartLink';

import Media from 'css/Media';


const EventCard = props => {
    const getDate = (date) => {
        return capitalize(moment(date).format('D.')) + ' ' + capitalize(moment(date).format('MMM YYYY'));
    }
    const getDateRange = (from, to) => {
        return (
            moment(from).format('D.') + ' ' + capitalize(moment(from).format('MMM')) + ' - ' + moment(to).format('D.') + ' ' + capitalize(moment(to).format('MMM YYYY'))
        )
    }

    const { event } = props;

    return (
        <Wrapper>
            <SmartLink to={event.link}>
                <ImageOverlay>
                    <Image image={event.acf.image} background ratio="5:4">
                        <Caption>
                            <IconSelector icon="calender" negative />
                            <span>{event.acf.end_date ? getDateRange(event.acf.from_date, event.acf.end_date) : getDate(event.acf.from_date)}</span>
                        </Caption>
                    </Image>
                </ImageOverlay>
                <span>{event.acf.title}</span>
            </SmartLink>
        </Wrapper>
    )
}

export default EventCard;

const Wrapper = styled.div`
    span {
        ${props => props.theme.fonts.h4};
    }

    &:hover {
        span {
            text-decoration: underline;
        }
    }
`

const ImageOverlay = styled.div`
    &::after {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        content: '';
        background-color: transparent;
        transition: all .2s ease-in;
    }

    &:hover {
        &::after {
            background-color: rgba(0, 0, 0, .2);
        }
    }
    margin-bottom: ${props => props.theme.spacing.contentL};
`

const Caption = styled.div`
    position: absolute;
    bottom: ${props => props.theme.spacing.contentXL};
    left: ${props => props.theme.spacing.contentL};
    display: flex;
    z-index: 2;

    span {
        font-size: 16px!important;
        color: ${props => props.theme.colors.negative}!important;
    
        ${Media.greaterThan('s')`
            font-size: 18px!important;
        `}
    }
`